<template>
  <div id="quiz">
    <div class="quiz-container">
      <ui-box>
        <template v-slot:nav-left>
          <ui-tag
            v-for="(tab, index) in quizType"
            :key="index"
            :id="tab.type"
            :active="subType === tab.type"
            :data-id="`id-${index}`"
            @click.native="switchType(tab.type)"
          >
            <div class="label-box">
              <span class="label-shadow">{{ tab.name }}</span>
              <span class="label-text">{{ tab.name }}</span>
            </div>
            <TipDot v-show="getTipDotVisibility(tab.type)" placement="quiz"></TipDot> 
          </ui-tag>
        </template>
        <template v-slot:nav-right>
          <div class="nav-right-box">
            <ui-frame-bg class="modal-btn quiz-rule" colorType="green" hook @click.native="handleRule">
              <i></i>
              <div class="label-box">
                <span class="label-shadow">竞猜规则</span>
                <span class="label-text">竞猜规则</span>
              </div>
            </ui-frame-bg>
            <ui-frame-bg class="modal-btn quiz-record" colorType="green" hook  @click.native="handleHistory">
              <i></i>
              <div class="label-box">
                <span class="label-shadow">竞猜记录</span>
                <span class="label-text">竞猜记录</span>
              </div>
            </ui-frame-bg>
            <div class="switch-source" v-if="quizSchedule.length">
              <ui-frame-bg class="switch-btn" colorType="blue" hook @click.native="showSelect = !showSelect">
                <div class="label-box">
                  <span class="label-shadow">{{ subSchedule?.name }}</span>
                  <span class="label-text">{{ subSchedule?.name }}</span>
                </div>
                <i :class="{ active: showSelect }"></i>
              </ui-frame-bg>
              <SelectList
                class="switch-list-box"
                v-show="showSelect"
                :list="quizSchedule"
                :defaultID="defaultScheduleID"
                @handleSwitch="switchSchedule"
                :showSelect="showSelect"
                :displaySelect=displaySelect
              ></SelectList>
            </div>
          </div>
        </template>
        <template v-slot:container>
          <QuizBox
            :subMatch="subMatch"
            :rounds="rounds"
            :subType="subType"
            :quizList="quizList"
            :quizSchedule="quizSchedule"
            :defaultScheduleID="defaultScheduleID"
            :subSchedule="subSchedule"
          ></QuizBox>
        </template>
      </ui-box>
    </div>
    <!-- 竞猜投注 弹窗 -->
    <Betting ref="betting"></Betting>
    <History ref="history"></History>
    <Rule ref="rule"></Rule>
    <ParticipateTeams ref="teamsModal"></ParticipateTeams>
    <Prompt ref="prompt"></Prompt>
  </div>
</template>

<script>
import QuizBox from '@/views/quiz/layout/quizBox'

import * as api from '@/service/index'
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';
import TipDot from '@/components/tip-dot.vue'
import SelectList from "@/components/select";
import Betting from '@/views/quiz/betting'
import History from '@/views/quiz/history'
import Rule from '@/views/quiz/rule'
import { mapState, mapMutations, mapActions} from 'vuex'
import ParticipateTeams from '@/views/schedule/participateTeams'
import Prompt from '@/components/prompt'

export default {
  components: {
    QuizBox,
    Betting,
    History,
    Rule,
    ParticipateTeams,
    Prompt,
    UiBox,
    UiTag,
    UiFrameBg,
    TipDot,
    SelectList
  },
  provide() {
    return {
      switchSchedule: this.switchSchedule,
      handleQuiz: this.handleQuiz,
      switchType: this.switchType,
      switchMatch: this.switchMatch,
      handleHistory: this.handleHistory,
      handleRule: this.handleRule,
      handleResult: this.handleResult,

      promptListen: () => {
        return this.promptListen
      }
    }
  },
  data() {
    return {
      subType: 'schedule',
      showSelect: false,
      quizList: [],

      defaultScheduleID: '',
      quizSchedule: [],
      subSchedule: {},
      subScheduleTeams: [],

      rounds: [],
      subMatch: 0,
      subSeasonID: '',
      promptListen: {
        id: '',
        msg: ''
      },
      typeInnings: 'schedule',
      dataObj: {
        schedule: 1,
        live: 2,
        rank_pk: 3,
        disuse_pk: 4
      },
      listData: [],
      // redPrompt: false

      quizType: [
        { name: '赛程竞猜', type: 'schedule' },
        { name: '实时竞猜', type: 'live' },
        { name: '排名PK', type: 'rank_pk' },
        { name: '淘汰PK', type: 'disuse_pk' }
      ]
    }
  },
  filters: {
    time: (val) => {
      let dateZh = ['日', '一', '二', '三', '四', '五', '六']
      let date = new Date(val)
      // 月/日
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = date.getDate()
      day = day < 10 ? '0' + day : day
      // 小时/分钟
      let hour = date.getHours()
      hour = hour < 10 ? '0' + hour : hour
      let min = date.getMinutes()
      min = min < 10 ? '0' + min : min

      return `${month}/${day}(周${dateZh[date.getDay()]}) ${hour}:${min} 截止`
    }
  },
  computed: {
    ...mapState([
      'amount',
      'userInfo',
      'token',
      'seasonInfo',
      'showLingqu',
      'dailyTasksList'
    ])
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.subSeasonID = newVal.id
          // 获取当前赛季的参赛队伍
          this.initQuiz()
          // this.fetchActivityList()
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...mapActions(['reqRedDotState']),
    ...mapMutations(['SET_SCHEDULE', 'SET_INFO', 'SET_SHOWLINGQU']),
    async initQuiz() {
      // 获取所有赛程
      if(!this.token) return;
      let response = await api.reqScheduleList({
        seasonId: this.subSeasonID,
        token: this.token
      })
      if (response.status == 200) {
        let list = []
        let schedule = response.data
        schedule = schedule && schedule.length != 0 ? schedule : []
        this.SET_SCHEDULE(schedule)
        schedule.forEach((item) => {
          let time = this.formatDay(new Date(item.startAt))
          list.push({
            id: item.scheduleCode,
            name: `${time} ${item.name}`,
            startAt: item.startAt,
            isPresent: item.isPresent
          })
        })
        this.defaultScheduleID = list.find((item) => item.isPresent)?.id
        this.quizSchedule = list
      }
    },

    // 入参， 赛程id   比赛id
    async getQuestionList(scheduleCode, matchCode, type) {
      if (scheduleCode == null) {
        return
      }
      //  matchCode  {0:赛程竞猜,1,实时竞猜,2:?,3:?}无配置

      this.subMatch = matchCode
      this.quizList = []
      let data = {
        scheduleCode: scheduleCode,
        matchCode: matchCode,
        token: this.token,
        seasonId: this.subSeasonID,
        quizType: this.dataObj[type] ? this.dataObj[type] : ''
      }
      let response = await api.reqQuestionList(data)
      if (response.status == 200) {
        let t_quizList = response.data

        // 判断返回的竞猜列表，未设置答案 && 时间有效 && 没有参与
        const valid = t_quizList.find((item) => item.isHint)
        if (valid) {
          this.SET_INFO({
            key: 'isHintSchedule',
            val: true
          })
        }

        // 获取该赛程参赛队伍
        // let promise_list = [];
        const promises = t_quizList.map(async (item) => {
          try {
            let teamList = []
            if (item.stype === 1) {
              teamList = await this.getSubScheduleTeams(scheduleCode, item.id)
            }
            return {
              ...item,
              teamList
            }
          } catch (error) {
            return {
              ...item,
              teamList: []
            }
          }
        })
        const newTQuizList = await Promise.all(promises)
        this.quizList = newTQuizList
      }
    },
    async getSubScheduleTeams(scheduleCode, questionId) {
      let response = await api.reqScheduleTeams({
        scheduleCode: scheduleCode,
        seasonId: this.subSeasonID,
        token: this.token,
        questionId: questionId || 0
      })
      if (response.status == 200) {
        // this.subScheduleTeams = response.data;
        return response.data
      } else {
        return []
      }
    },

    async switchType(type) {
      // console.log('我是quiz', type)
      if (type === this.subType) {
        return
      }
      // 
      this.subType = type
      this.quizList = []

      this.reqRedDotState()

      // 渲染 Live函数  因函数作用域被提前，拿不到subSeasonID，改成箭头函数把
      const getLivedataBase = async (type) => {
        // console.log('我是live');
        // console.log('this.subSeasonID',this.subSeasonID)
        const dataObj = {
          seasonId: this.subSeasonID,
          scheduleCode: this.subSchedule.id,
          token: this.token
        }
        try {
          let { status, data } = await api.reqMatchList(dataObj)
          if (status === 200) {
            this.rounds = data
            const presentMatch = this.rounds.find((item) => item.isPresent)
            // console.log('presentMatch',presentMatch);
            if (presentMatch) {
              this.getQuestionList(
                this.subSchedule.id,
                presentMatch.matchCode,
                type
              )
            }
          }
        } catch (err) {
          console.error(err)
        }
      }
      // 排名PK
      switch (type) {
        case 'live':
        case 'disuse_pk':
        case 'rank_pk':
          getLivedataBase(type)
          break
        case 'schedule':
          {
            this.getQuestionList(this.subSchedule.id, 0, type)
          }
          break
        default:
      }
    },
    // 首次渲染的默认的数据，赛事竞猜
    switchSchedule(scheduleCode) {
      if (scheduleCode == null) {
        return
      }
      if (scheduleCode != this.subSchedule.id) {
        this.subSchedule = this.quizSchedule.find(
          (item) => item.id == scheduleCode
        )
        // this.showSelect = false;

        // 获取该赛程code的竞猜列表
        this.getQuestionList(scheduleCode, this.subMatch, this.subType)

        // 埋点
        if (typeof tapdb == 'undefined') return
        tapdb.trackEvent('切换阶段')
      }
    },
    async switchMatch(matchCode) {
      // console.log('2222', this.subType);
      if (matchCode != this.subMatch) {
        // 选择第几局的时候，传一下当前的类别this.dateObj
        // console.log('Inning',this.dataObj);
        // console.log('Inning', this.subType)
        this.getQuestionList(this.subSchedule.id, matchCode, this.subType)
      }
    },
    getDateTime(date) {
      return new Date(date).getTime()
    },
    async handleQuiz(quizInfo, selectInfo, answerInfo, index) {
      // console.log('selectInfo',selectInfo, index);
      // console.log('竞猜的也的',selectInfo.answers[index].popularity);
      if (quizInfo.answer && quizInfo.answer != 0) {
        this.promptListen = {
          id: `prompt${quizInfo.id}`,
          msg: '本场竞猜已结束'
        }
        return
      }

      // 获取服务器时间
      let currentTime = new Date()
      let result = await api.reqcurrentTime()
      if (result.status == 200) {
        currentTime = result.data
      }
      const getServerCurrentTime = this.getDateTime(currentTime)
      if (getServerCurrentTime >= this.getDateTime(quizInfo.endAt)) {
        this.promptListen = {
          id: `prompt${quizInfo.id}`,
          msg: '本场竞猜已结束'
        }
        return
      }

      if (getServerCurrentTime < this.getDateTime(quizInfo.startAt)) {
        this.promptListen = {
          id: `prompt${quizInfo.id}`,
          msg: '本场竞猜未开始'
        }
        return
      }
       // 竞猜币上限
      if(this.amount.quizRemainNum >=99999){
        // this.$refs.prompt.setMsg('竞猜币已达上限,无法继续竞猜')
        // this.$parent.handleBettingLimit()
         this.$refs.prompt.setMsg('竞猜币已达上限,无法继续竞猜')
        return
      }
      // console.log('handleQuiz');
      // console.log('quizInfo.type',quizInfo);
      // console.log('quizInfo.stype',selectInfo);
      // console.log('handleQuiz');
      let obj = {}
      let other = {}
      if (quizInfo.type == 1 && quizInfo.stype == 1) {
        // 战队预测
        obj = {
          question_id: quizInfo.id,
          lossRate: selectInfo.lossRate || 0,
          obj_avatar: selectInfo.avatar,
          obj_name: selectInfo.name,
          answer_code: selectInfo.teamCode,
          answer_name: selectInfo.name,
          ratios: selectInfo.popularity
        }

        other = {
          stype: 1,
          subType: this.subType,
          schedule_id: this.subSchedule.name,
          match_title: quizInfo.title,
          match_id: this.subMatch,
          type: ''
        }
      } else if (quizInfo.type == 2 && quizInfo.stype == 2) {
        let objInfo = selectInfo.objList[index] || {}
        // 单个预测
        obj = {
          question_id: quizInfo.id,
          lossRate: answerInfo.lossRate || 0,
          obj_avatar: objInfo.avatar || '',
          obj_name: objInfo.name || '',
          answer_code: answerInfo.answerCode,
          answer_name: answerInfo.answer,
          ratios: selectInfo.answers[index].popularity
        }

        other = {
          stype: 2,
          subType: this.subType,
          schedule_id: this.subSchedule.name,
          match_title: quizInfo['questionDetail']['title'],
          match_id: this.subMatch,
          type: quizInfo.title
        }
      } else if (quizInfo.type == 3 && quizInfo.stype == 2) {
        let objInfo = selectInfo.objList[index]
        // console.log('123');
        obj = {
          question_id: quizInfo.id,
          lossRate: answerInfo.lossRate || 0,
          obj_avatar: objInfo.avatar || '',
          obj_name: objInfo.name || '',
          answer_code: answerInfo.answerCode,
          answer_name: answerInfo.answer,
          ratios: selectInfo.answers[index].popularity
        }
        // 当前竞猜队伍信息（后台配置的对应信息）
        other = {
          stype: 2,
          subType: this.subType,
          schedule_id: this.subSchedule.name,
          match_title: quizInfo['questionDetail']['title'],
          match_id: this.subMatch,
          type: quizInfo.title
        }
      
      } else if (quizInfo.type == 4 && quizInfo.stype == 2) {
        // 4: 淘汰PK
        // console.log('456');
        let objInfo = selectInfo.objList[index]
        // console.log('obj let objInfo = selectInfo.objList[0]ect',objInfo);
        // console.log('objInfo',objInfo);
        // 当前竞猜队伍信息，左右赔率信息等
        obj = {
          question_id: quizInfo.id,
          lossRate: answerInfo.lossRate || 0,
          obj_avatar: objInfo.avatar || '',
          obj_name: objInfo.name || '',
          answer_code: answerInfo.answerCode,
          answer_name: answerInfo.answer,
          ratios: selectInfo.answers[index].popularity
        }
        // 当前竞猜队伍信息（后台配置的对应信息）
        other = {
          stype: 2,
          subType: this.subType,
          schedule_id: this.subSchedule.name,
          match_title: quizInfo['questionDetail']['title'],
          match_id: this.subMatch,
          type: quizInfo.title
        }
      }
      // obj 获取下注信息，other 获取埋点信息
      this.$refs.betting.quiz(obj, other)
      // 埋点
      if (typeof tapdb == 'undefined') {
        return
      }
      //   埋点函数 排名PK 淘汰PK
      const buriedFunctions = (subType, type) => {
        const raceType = {
          schedule: '赛程竞猜',
          live: '实时竞猜',
          rank_pk: '排名PK',
          disuse_pk: '淘汰PK'
        }
        switch (type) {
          case 1:
            {
              tapdb.trackEvent(raceType[subType], {
                '#schedule_id': this.subSchedule.name,
                '#match_title': quizInfo.title,
                '#match_id': this.subMatch
              })
            }
            break
          case 2:
            {
              tapdb.trackEvent(raceType[subType], {
                '#schedule_id': this.subSchedule.name,
                '#match_title': quizInfo['questionDetail']['title'],
                '#match_id': this.subMatch,
                '#type': quizInfo.title
              })
            }
            break
          default:
        }
      }
      buriedFunctions(this.subType, quizInfo.stype)
    },
    formatDay(dateObj) {
      let month = dateObj.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = dateObj.getDate()
      day = day < 10 ? '0' + day : day

      return `${month}/${day}`
    },
    handleHistory() {
      this.$refs.history.getHistory()

      // 埋点
      if (typeof tapdb == 'undefined') return
      tapdb.trackEvent('竞猜记录')
    },

    handleRule() {
      this.$refs.rule.rule()

      // 埋点
      if (typeof tapdb == 'undefined') return
      tapdb.trackEvent('竞猜规则')
    },
    handleResult(info) {
      const { answers, teamList } = info
      let resultTeams = answers.map((item) => {
        let subTeam = teamList.find((o) => item.answerCode === o.teamCode)
        return subTeam
      })
      // console.log('resultTeams',resultTeams);
      // console.log('subScheduleTeams',this.subScheduleTeams);
      this.$refs.teamsModal.initTeams(resultTeams, '本场晋级')
    },
    getTipDotVisibility(type) {
      const visibilityMap = {
        schedule:this.showLingqu.quizHots.quizSchedule,
        live:this.showLingqu.quizHots.quizReal,
        rank_pk:this.showLingqu.quizHots.quizRank,
        disuse_pk :this.showLingqu.quizHots.quizElimi
      };
      return visibilityMap[type] || false;
    },
    displaySelect() {
      this.showSelect = false
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "~@/assets/scss/quiz/index";
#quiz {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: get_percentage(730px);
  position: relative;
  .quiz-container {
    flex: 1;
    height: 100%;
    margin: 0 get_vh(16px) 0;
    border-radius: get_vh(20px);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .nav-right-box {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .modal-btn {
        @include sizeSet($width: 130px, $height: 40px);
        @include marginSet($marginRight: 14px);
        @include fontSet(20px);
        @include boxShadowSet_Btn;
        &.quiz-rule {
          i {
            @include sizeSet($width: 25px, $height: 25px);
            @include icon_status('btn_quiz_rule', $hook: 'all');
            @include marginSet($marginRight: 5px);
          }
        }
        &.quiz-record {
          i {
            @include sizeSet($width: 25px, $height: 25px);
            @include icon_status('btn_quiz_record', $hook: 'all');
            @include marginSet($marginRight: 5px);
          }
        }
      }
      .switch-source {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .switch-btn {
          height: get_vh(40px);
          width: get_vh(157px);
          @include fontSet(14px);
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;
          @include boxShadowSet_Btn;
        
          i {
            display: inline-block;
            @include sizeSet($width: 12px, $height: 12px);
            background-image: $bg_btn;
            background-size: get_vh(786px) get_vh(384px);
            background-position: get_vh(-626px) get_vh(-222px);
            background-repeat: no-repeat;
            margin-left: get_vh(5px);
            margin-top: get_vh(-5px);
            transform-origin: center;
            &.active {
              transform: rotate(180deg);
              margin-top: 0px;
            }
          }

          ::v-deep .inner-box {
            @include paddingSet($paddingRight: 10px, $paddingLeft: 10px);
          }
        }

        .switch-list-box {
          width: get_vh(240px);
          max-height: 56vh;
          overflow: scroll;
          position: absolute;
          right: 0;
          top: get_vh(44px);
          z-index: 2;
          ::v-deep .label-box {
            .label-shadow {
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .label-text {
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        @include hideScrollBar();
      }
    }
  }
}

@media screen and (max-aspect-ratio: 3/2) {
  #quiz {
    .quiz-container {
      .nav-right-box {
        .switch-source {
          .switch-btn {
            width: get_vw(157px);
            height: get_vw(40px);
            i {
              background-size: get_vw(786px) get_vw(384px);
              background-position: get_vw(-626px) get_vw(-222px);
              margin-left: get_vw(5px);
              margin-top: get_vw(-5px);
            }
          }

          .switch-list-box {
            width: get_vw(240px);
            max-height: 42vw;
            top: get_vw(44px);
          }
        }
      }
    }
  }
}
</style>